module.exports = __webpack_public_path__ + "assets/img/liyou.df53e122.png";